import moment from "moment";

/**
 * 格式化时间戳
 * @return {string}
 */
function XTime(X) {
    return moment(X * 1000).format('YYYY-MM-DD HH:mm:ss');
}

/**
 * 开始时间戳
 * @returns {string}
 */
function StartTime(time = 'day') {
    return moment().startOf(time).format('X')
}

/**
 * 结束时间戳
 * @returns {string}
 */
function EndTime(time = 'day') {
    return moment().endOf(time).format('X')
}

function monthTime(x) {
    switch (x) {
        case 'start':
            return moment().startOf('month').format('YYYY-MM');
        case 'end':
            return moment().endOf('month').format('YYYY-MM');
        default:
            return moment(x * 1000).format('YYYY-MM');
    }
}

/**
 * 计算时间差
 * @param endTime
 */
function difference(startTime, endTime) {
    if (endTime === null || endTime === undefined) {
        return " ";
    }
    if (endTime.toString().length === 10) {
        endTime = parseInt(endTime) * 1000;
    }
    if (endTime === 0) {
        endTime = new Date();
    }
    return moment(endTime).diff(moment(startTime * 1000), 'minute');
}
function strToDate (str) {
    return new Date(str)
}
const dateFormatToYMDHMS = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return year+'-'+month+'-'+day+' '+hours+':'+minutes+':'+seconds
}


export {
    monthTime,
    difference,
    XTime,
    StartTime,
    EndTime,
    strToDate,
    dateFormatToYMDHMS,
}